package com.milta.feature.optimizationquota.domain.usecase

import com.milta.feature.optimizationquota.domain.entity.OptimizationLimits
import com.milta.feature.optimizationquota.domain.repository.OptimizationQuotaRepository

class UpdateOptimizationLimitsUseCase(private val repository: OptimizationQuotaRepository) {
    suspend operator fun invoke(limits: OptimizationLimits): Result<OptimizationLimits> = repository.updateLimits(limits)
}
